import React from 'react';
import times from 'lodash/times';
import {
  Content,
  StickyFooter,
} from '../../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { StepCard } from '../StepCard/StepCard';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { TextLoading } from '../../../../../CommonComponents/OPL/Text/Text.loading';
import { Shimmer } from '../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const StepLoading = () => {
  return (
    <Box minWidth={500} mt={96}>
      <Content>
        <StepCard>
          <TextLoading width={300} height="h2" mb="32" />

          <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
            {times(4).map(key => (
              <Shimmer key={key} width="100%" height={80} />
            ))}
          </Box>
        </StepCard>
      </Content>

      <StickyFooter />
    </Box>
  );
};
